import { render, staticRenderFns } from "./compont.vue?vue&type=template&id=5966a126&scoped=true"
import script from "./compont.vue?vue&type=script&lang=js"
export * from "./compont.vue?vue&type=script&lang=js"
import style0 from "./compont.vue?vue&type=style&index=0&id=5966a126&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966a126",
  null
  
)

export default component.exports